import { getLeadDisplayName } from './leadDisplayName';

interface LeadHeaderContact {
  name?: string | null;
  isPrimary?: boolean | null;
}

interface LeadHeaderIdentityInput {
  fullName?: string | null;
  company?: string | null;
  email?: string | null;
  customFields?: Record<string, unknown> | null;
  contacts?: LeadHeaderContact[] | null;
}

export interface LeadHeaderIdentity {
  name: string;
  company: string | null;
}

/**
 * Resolves the identity shown in the lead detail header (FLOSEAI-531): the
 * large primary name and the secondary company subtitle that also drive the
 * avatar initials. A primary contact wins, then the derived display name, then
 * the caller-supplied fallback. The company is rendered as a subtitle only when
 * it differs from the resolved name so it is never repeated.
 */
export function getLeadHeaderIdentity(
  lead: LeadHeaderIdentityInput | null | undefined,
  fallback: string,
): LeadHeaderIdentity {
  const primaryContact = lead?.contacts?.find((c) => c.isPrimary) ?? lead?.contacts?.[0];
  const name = primaryContact?.name?.trim() || getLeadDisplayName(lead) || fallback;
  const company =
    lead?.company?.trim() && lead.company.trim() !== name ? lead.company.trim() : null;

  return { name, company };
}
